// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eIff","newExpiryDate":"styles_newExpiryDate__1-2Q-","footer":"styles_footer__3umPi"};